import { media, styled } from "@styles";
import { css } from "styled-components";

const textProps = css`
  font-size: ${props => props.theme.typography.baseFontSize};
  margin: 0 0 0.5rem 0;
  text-align: left;
`;

export const Wrapper = styled.div`
  background: transparent;
  padding: 0;
  text-align: center;
`;

export const Title = styled.h4`
  text-transform: uppercase;
  font-weight: normal;
  ${textProps}
`;

export const Price = styled.p`
  ${textProps}
`;

export const Image = styled.div`
  align-items: center;
  background-color: transparent;
  box-sizing: border-box;
  display: flex;
  height: 22rem;
  justify-content: center;
  max-width: 100%;
  overflow: hidden;
  padding: 1.5rem;
  transition: background-color 180ms ease;

  > img {
    height: 100%;
    max-width: 100%;
    max-height: 100%;
    mix-blend-mode: multiply;
    object-fit: contain;
    transition: transform 180ms ease;
    width: 100%;
  }

  :hover {
    background-color: ${props => props.theme.colors.hoverLightBackground};

    > img {
      transform: scale(1.02);
    }
  }

  ${media.largeScreen`
    height: 17rem;
    padding: 1.25rem;
  `}

  ${media.smallScreen`
    height: 14rem;
    padding: 1rem;
  `}
`;
